import React, { useState, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PredictionForm from '../components/PredictionForm';
import UserPredictions from '../components/UserPredictions';
import { AuthContext } from '../context/AuthContext';

function Predictions() {
  const { user, loading } = useContext(AuthContext);
  // Add the new state variable right here
  const [showPointsBreakdown, setShowPointsBreakdown] = useState(false);  
  // If not logged in and not loading, redirect to login
  if (!loading && !user) {
    return <Navigate to="/login" />;
  }
  
  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">F1 Predictions</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-bold mb-4">Make Your Predictions</h2>
          <ul className="space-y-4 pl-5"> {/* Increased spacing between items */}
            <li>To see your selections, refresh the page after submitting</li>
            </ul>
          <PredictionForm />
        </div>
        
        <div>
          <div className="bg-white rounded-lg shadow-md p-6 mb-8"> {/* Increased padding and margin */}
            <div 
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setShowPointsBreakdown(!showPointsBreakdown)}
            >
                <div style={{ height: '60px' }}></div>
              <h2 className="text-xl font-bold text-gray-800">Points Breakdown</h2>
              <div className="flex items-center">
                <span className="text-sm font-bold text-gray-800">Click for scoring details</span> {/* Removed list item and added text */}
                <span className="text-gray-800">{showPointsBreakdown ? '▲' : '▼'}</span>
              </div>
            </div>
            
            {showPointsBreakdown && (
              <div className="mt-6"> {/* Increased top margin */}
                <p className="mb-4">Here's how each category is scored:</p>
                
                <ul className="space-y-4 pl-5"> {/* Increased spacing between items */}
                    <li><strong>Pole (2 points):</strong> As listed on official results as finshing in 1st place in qualifying on the official classification results.</li>
                    
                    <li><strong>Winning Driver (6 points):</strong> As listed on official results as finshing in 1st place in the race.</li>
                    
                    <li><strong>Race 2nd (4 points):</strong> Predicting the driver who finishes the race in second place.</li>
                    
                    <li><strong>Race 3rd (2 points):</strong> Predicting the driver who finishes the race in third place.</li>
                    
                    <li><strong>Fastest Lap (1 point):</strong> Predicting the driver who sets the fastest lap time during the race.</li>
                    
                    <li><strong>First retirement (1 point):</strong> Predicting the driver who finishes in last place as listed on the official classification results.</li>
                    
                    <li><strong>Driver Head to Head (1 point):</strong> Which driver will finish higher - based on the official classification results listed on the official classification results. If the 2 drivers crash and take each other out, the winner is the one listed above the other in official results.</li>
                    
                    <li><strong>Team Head to Head (1 point):</strong> Which team will have the higher average finishing position (add both driver positions and divide by 2).  E.g. If Team A finished 1st and 20th, and Team B finished 9th and 10th, Team B will will win as their ave position was 9.5, Team A's ave was 10.5.</li>
                    
                    <li><strong>Top 3 any order (2 bonus points):</strong> Predicting the three drivers who will finish in the top three positions, regardless of their exact finishing order.</li>
                    
                    <li><strong>Top 3 in order (6 bonus points):</strong> Predicting the exact finishing order of the top three drivers (1st, 2nd, and 3rd).</li>
                    </ul>
            </div>
          )}
        </div>
        
        <UserPredictions /> {/* This will now have more space above it */}
      </div>
    </div>
  </div>
);
}

export default Predictions;